// @flow
export const EVENT_NAME_CTA_CLICKED = 'CTA Clicked';
export const EVENT_NAME_PAGE_LOADED = 'Page Loaded';
export const EVENT_NAME_SUBSCRIPTION_FORM_SUBMITTED = 'Subscription Form Submitted';
export const EVENT_NAME_ORDER_FORM_SUBMITTED = 'Order Form Submitted';

export type TrackingEventName = typeof EVENT_NAME_PAGE_LOADED
| typeof EVENT_NAME_CTA_CLICKED
| typeof EVENT_NAME_SUBSCRIPTION_FORM_SUBMITTED
| typeof EVENT_NAME_ORDER_FORM_SUBMITTED;
